module.exports = __webpack_public_path__ + "img/langTW.ca1b2a52.svg";